import { createSlice } from "@reduxjs/toolkit";
import { updateUserPreference, fetchLogs, fetchLogsTableColumnNames  } from "./thunk";
import { toast } from 'react-toastify';

const initialState = {
  preferences: {},
  logs: [],
  tableColumnNames: [],
  loading: false,
  error: null,
};

const logsSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Localization Table Column Names API
      .addCase(fetchLogsTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLogsTableColumnNames.fulfilled, (state, action) => {        
        state.loading = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchLogsTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Logs API
      .addCase(fetchLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLogs.fulfilled, (state, action) => {        
        state.loading = false;
        state.logs = action.payload;
      })
      .addCase(fetchLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default logsSlice.reducer;
